
import { mapGetters } from "vuex"
import capitalize from "lodash/capitalize"
import groupBy from "lodash/groupBy"
import map from "lodash/map"
import uniqBy from "lodash/uniqBy"

export default {
  props: {
    path: { type: String, required: true },
    alias: { type: String, required: true },
    asGroups: { type: Boolean, default: false },
    cardHoverable: { type: Boolean, default: true },
    title: { type: [Boolean, String], default: null },
    display: { type: [Boolean, Array], default: () => [] },
    fetch: { type: Function, required: true },
    params: { type: Object, default: () => ({}) },
    listKey: { type: String, default: "alias" },
  },

  data: () => ({
    items: null,
    groups: null,
    loading: true,
    paginator: {},
    limit: 12,
  }),

  async fetch () {
    await this.fetchItems()
  },

  head () {
    return {
      title: this.getTitle(this.$t(`pages.${this.alias}.title`)),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),

    component () {
      const name = `${this.capitalize(this.path)}Card`
      return () => import(`@/components/cards/${name}`)
    },

    filters: {
      get () { return { ...this.$route.query } },
      set (filters) {
        this.$router.push({ query: filters })
      },
    },

    formattedFilters () {
      return Object.fromEntries(Object.entries(this.filters)
        .map(e => [`filter[${e[0]}]`, e[1]]))
    },

    page () { return this.$route.query.page || 1 },
    search () { return this.$route.query.search || "" },

    listEmpty () {
      const emptyItems = this.asGroups
        ? !Object.keys(this.items).length
        : !this.items.length
      return emptyItems
    },

    searchEmpty () {
      return this.search.length > 0 && this.listEmpty
    },

    completeParams () {
      return {
        ...this.formattedFilters,
        ...this.params,
        "paginator[limit]": this.limit,
        "paginator[page]": this.page > 1 ? this.page : null,
        "filter[search]": this.search.length > 1 ? this.search : null,
      }
    },

    enableFilters () { return this.display.includes("filters") },
    enableSearch () { return this.display.includes("search") },
  },

  watch: {
    completeParams: {
      handler () { this.fetchItems() },
      deep: true,
    },
  },

  methods: {
    capitalize,

    changePage (page) {
      this.$router.push({ query: { page: page > 1 ? page : undefined } })
      window.scrollTo(0, 0)
    },

    async fetchItems () {
      const [res, err] = await this.fetch({ params: this.completeParams })
      if (err) {
        this.$nuxt.error({ statusCode: 500 })
      } else {
        const items = this.$api.helpers.getList(res)
        if (this.asGroups) {
          this.items = groupBy(items, "groups[0].alias")
          this.groups = uniqBy(map(items, "groups[0]"), "alias") || null
        } else { this.items = items }
        this.paginator = res.paginator
        this.loading = false
      }
    },

    groupTitle (alias) {
      if (!this.groups) return
      const result = this.groups.find(entry => entry.alias === alias)
      return result.title[this.$i18n.locale]
    },
  },
}
